export const amain = {
  url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp1.png?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLW5vcnRoZWFzdC0yIkgwRgIhANg11QkwKH6mBaoL7jxPcvSFUVzczKOzYtLwEAiJ84%2ByAiEA3Sz8tAVbSKr%2FNHxO%2B7xGbUtQLBlRykZG23HhEuGhzYYq7QII6f%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMzcxNDQ3NjYwNzAiDCZfdyvCArLzgcC%2BvirBAo6J1wvKzlPecckTcqKccJPo1p76zTDCC%2BYMIJyuKmFpB2eWlCy%2FWTQwkuEc%2BECPYZ8w5RttIfXf7ajEDWWjbuS1JTq3a6vi6JtsHtBjjJqltDPo%2BRymL2UKapAHko8uoZhIvBKyAuGDPBNjIXC42%2FA5i7PsOsOSieFW0qE0JOgCf83SnVJJlqgLcZRkDnTKFqToo0xwallHcOh2DoD5aLpEKi5OAEwCqOzQDqQMvGgaPnbPjvKGoE06OJ5W6Vyc4AZaMA%2F0GlM2S2C6fB3hXd50yZFD53wbVYV6uOGDlYQxzgwbsnM5KPrdLqa%2FCuANyUZ4vqxnnC4uNeBWAavrBQ2nyM%2BsI2VQBtg%2FME2ttyVlSftPR42YEmZiY3liWD69z1eZp%2BZLN04zD3U7wuysnRaH8rm3qvEjgrV5YYkfUrH8fDDx%2FLajBjqyAtLRYUd5a5meRhnpWE1DcOBNvd%2FnmH4hE7KOXY0c0as%2BnF8Ov5FshtYJag2xuP7STzAz6XKJtJqmqw6njfKExemAOKiGbr88CSTV0kbzuM5trU4585uky0hPd%2BgVhikjuF4yvZ5I55ML2CH%2BOaElq3%2Fu%2BUoKltcVYztefqcJ4y7EB2m4NMUhom9nfQeYoHxJrVN5J7upF9MdmBcS68NOih8UvgyOZvqi1xze8Nx%2Fia1hF0ck9Zg2BERzwb%2BD7J2oeU7Q38DxzIBKmUPZGtnJY1vkBcvOn3BFdmaCJHvkL4dRFPe%2F2uZf8NlxU6x8IR2V7%2FbsKxwKoAjDHTx6q4dbktl7sSmRskrtvk%2F8DUKMzGTu7eGeDCRmTTLZAUIBhYLdmzgKO5QvjAWf537V4%2Fsh1ZWvlQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230524T091439Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIATONXN6Z3M3FIZSES%2F20230524%2Fap-northeast-3%2Fs3%2Faws4_request&X-Amz-Signature=1d7c8838c4b0eacd23a97aa33fa81d9e4dbae6ddc0e2d913b09d5584a8b6f395",
  poster: "",
  type: "video",
};
export const afile = [
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp1.png?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLW5vcnRoZWFzdC0yIkgwRgIhANg11QkwKH6mBaoL7jxPcvSFUVzczKOzYtLwEAiJ84%2ByAiEA3Sz8tAVbSKr%2FNHxO%2B7xGbUtQLBlRykZG23HhEuGhzYYq7QII6f%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMzcxNDQ3NjYwNzAiDCZfdyvCArLzgcC%2BvirBAo6J1wvKzlPecckTcqKccJPo1p76zTDCC%2BYMIJyuKmFpB2eWlCy%2FWTQwkuEc%2BECPYZ8w5RttIfXf7ajEDWWjbuS1JTq3a6vi6JtsHtBjjJqltDPo%2BRymL2UKapAHko8uoZhIvBKyAuGDPBNjIXC42%2FA5i7PsOsOSieFW0qE0JOgCf83SnVJJlqgLcZRkDnTKFqToo0xwallHcOh2DoD5aLpEKi5OAEwCqOzQDqQMvGgaPnbPjvKGoE06OJ5W6Vyc4AZaMA%2F0GlM2S2C6fB3hXd50yZFD53wbVYV6uOGDlYQxzgwbsnM5KPrdLqa%2FCuANyUZ4vqxnnC4uNeBWAavrBQ2nyM%2BsI2VQBtg%2FME2ttyVlSftPR42YEmZiY3liWD69z1eZp%2BZLN04zD3U7wuysnRaH8rm3qvEjgrV5YYkfUrH8fDDx%2FLajBjqyAtLRYUd5a5meRhnpWE1DcOBNvd%2FnmH4hE7KOXY0c0as%2BnF8Ov5FshtYJag2xuP7STzAz6XKJtJqmqw6njfKExemAOKiGbr88CSTV0kbzuM5trU4585uky0hPd%2BgVhikjuF4yvZ5I55ML2CH%2BOaElq3%2Fu%2BUoKltcVYztefqcJ4y7EB2m4NMUhom9nfQeYoHxJrVN5J7upF9MdmBcS68NOih8UvgyOZvqi1xze8Nx%2Fia1hF0ck9Zg2BERzwb%2BD7J2oeU7Q38DxzIBKmUPZGtnJY1vkBcvOn3BFdmaCJHvkL4dRFPe%2F2uZf8NlxU6x8IR2V7%2FbsKxwKoAjDHTx6q4dbktl7sSmRskrtvk%2F8DUKMzGTu7eGeDCRmTTLZAUIBhYLdmzgKO5QvjAWf537V4%2Fsh1ZWvlQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230524T091439Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIATONXN6Z3M3FIZSES%2F20230524%2Fap-northeast-3%2Fs3%2Faws4_request&X-Amz-Signature=1d7c8838c4b0eacd23a97aa33fa81d9e4dbae6ddc0e2d913b09d5584a8b6f395",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp2.png?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLW5vcnRoZWFzdC0yIkgwRgIhANg11QkwKH6mBaoL7jxPcvSFUVzczKOzYtLwEAiJ84%2ByAiEA3Sz8tAVbSKr%2FNHxO%2B7xGbUtQLBlRykZG23HhEuGhzYYq7QII6f%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMzcxNDQ3NjYwNzAiDCZfdyvCArLzgcC%2BvirBAo6J1wvKzlPecckTcqKccJPo1p76zTDCC%2BYMIJyuKmFpB2eWlCy%2FWTQwkuEc%2BECPYZ8w5RttIfXf7ajEDWWjbuS1JTq3a6vi6JtsHtBjjJqltDPo%2BRymL2UKapAHko8uoZhIvBKyAuGDPBNjIXC42%2FA5i7PsOsOSieFW0qE0JOgCf83SnVJJlqgLcZRkDnTKFqToo0xwallHcOh2DoD5aLpEKi5OAEwCqOzQDqQMvGgaPnbPjvKGoE06OJ5W6Vyc4AZaMA%2F0GlM2S2C6fB3hXd50yZFD53wbVYV6uOGDlYQxzgwbsnM5KPrdLqa%2FCuANyUZ4vqxnnC4uNeBWAavrBQ2nyM%2BsI2VQBtg%2FME2ttyVlSftPR42YEmZiY3liWD69z1eZp%2BZLN04zD3U7wuysnRaH8rm3qvEjgrV5YYkfUrH8fDDx%2FLajBjqyAtLRYUd5a5meRhnpWE1DcOBNvd%2FnmH4hE7KOXY0c0as%2BnF8Ov5FshtYJag2xuP7STzAz6XKJtJqmqw6njfKExemAOKiGbr88CSTV0kbzuM5trU4585uky0hPd%2BgVhikjuF4yvZ5I55ML2CH%2BOaElq3%2Fu%2BUoKltcVYztefqcJ4y7EB2m4NMUhom9nfQeYoHxJrVN5J7upF9MdmBcS68NOih8UvgyOZvqi1xze8Nx%2Fia1hF0ck9Zg2BERzwb%2BD7J2oeU7Q38DxzIBKmUPZGtnJY1vkBcvOn3BFdmaCJHvkL4dRFPe%2F2uZf8NlxU6x8IR2V7%2FbsKxwKoAjDHTx6q4dbktl7sSmRskrtvk%2F8DUKMzGTu7eGeDCRmTTLZAUIBhYLdmzgKO5QvjAWf537V4%2Fsh1ZWvlQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230524T091810Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIATONXN6Z3M3FIZSES%2F20230524%2Fap-northeast-3%2Fs3%2Faws4_request&X-Amz-Signature=dc48d7a868436498014dde14c01e168c38aa4161dd07fab88247734315349c91",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp3.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp8.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp5.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp6.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp7.png",
    type: "img",
  },

  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp9.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp10.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastycomp%20%280011.png?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjENH%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLW5vcnRoZWFzdC0yIkYwRAIgW4VrpNUM2gRfmByogi7%2BVvg3OPfYDR2oQVDp9CXSXqUCIDsn%2BpYgPWRfrZIIbhGmFuVfxM842PpVe0JEaSYSemGrKu0CCPr%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMMjM3MTQ0NzY2MDcwIgx%2Fi7iCpgR8BLKz%2BP4qwQItWVtxJbIwscN8Et9Mt2OJn78cxqL1SkqbKzZvXk7t2hJaU%2BILEfoFpSqCUej1U8MtUD7i2GAMa%2BOEUQUQwAgaUL%2B326%2B87gwMeS1YQ%2BpTTBb2OsCKkgl8NKFRfzrBtoj8a8fnW1y4DYtBrqJ0zyxFUI9n6TeddPdVxvaMOc2qinwSaOu%2B7%2B%2BsIIOjF8VzMVWLZzDsNBG9UG1xk1r8DFYeaD3tMy78cwAGHkNtfViqQtl9N94E9Fnm13WX7TgzOytG8KRV9Jcwiwm25li%2FdaMubNpSKJTcToXXYDWgRc7TRhgtoZGkivizrRTToqNPZ7Ta2%2BGJViMk4IW9%2F1IyEX3lpwbBNOPfoKQZQ6xcLUaNHr4iBBxEVaF6YQlOpKJEU%2F5FovPTOeuVt40RXuiawir517d%2FHEGNqXb8IkCPmx2B%2FX0w69i6owY6tAK1fQ19f9V1NvtDR5k%2FzPDoF1LlP%2FSALDqqIw1H1w29Ov4dk7qafqcDCyDAVRsFjVxXelwU%2F5pdbe%2FHkbXR9V34leem4LLPbLaRcTEMz%2B7ujHu2BV9aFlWzehiYPI4XZeswtYaNH6YZtyeAZNhKoT%2BE6k8bTIUw6hzQ3d8saogoEI1RRIn%2Bq%2BubRE770WvZFHMJU7ufUnoufvnsj9Id2xqmDd2AEDGsljyAwGXecvmuUGK5UbsXC%2BAZQIoM9Qx3DSZo0%2FE33qe5T%2F220ts5ko%2BTxfQEGfjFrXYOB3AxZPGttjmOLYQ8YlH31N9XHLFZ44eyTdV2PeA9ypatMhs5AqAF1g1%2FvINy0f35h%2BJMG2OuAy0dn1%2Fuqf8QYS4EGpnlCoc1sSZipNddEOjG%2Ba1sQNzIfcokuQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230525T032239Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIATONXN6Z3EDVSGTHX%2F20230525%2Fap-northeast-3%2Fs3%2Faws4_request&X-Amz-Signature=dcc07c8080a42783f25ff5363d6aaaa1ae60e1a2c4f7ba7918cd0c3ae43cf6df",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp12.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp13.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp14.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp15.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp16.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/icon1.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/LDG_height.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/LDG_illsample.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/artworks/lastcomp4.png",
    type: "img",
  },
];

export const ifile = [
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s1.png",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s4.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s5.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s6.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s7.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s8.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s9.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s10.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s11.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s12.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s13.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s14.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s15.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/sketch/s16.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/illustrate/i1.webp",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/illustrate/i2.webp",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/illustrate/i3.webp",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/illustrate/i4.webp",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/illustrate/i5.jpg",
    type: "img",
  },
  {
    url: "https://deuffzfddmyq6.cloudfront.net/videos/motel_1.mp4",
    type: "video",
  },
];
